import React from 'react';
import styles from './css/OtpFlow.module.css';

const OtpInput = ({
  index,
  inputRef,
  value,
  ...inputProps
}) => (
  <input
    ref={inputRef}
    aria-label={`OTP code (index ${index + 1})`}
    className={styles.OtpInput}
    id={`otp-input-${index}`}
    max={1}
    value={value}
    {...inputProps}
  />
);

export { OtpInput };
